export default function(texto: string) {
    return texto.length > 0 ? texto[0].toUpperCase() + texto.slice(1) : texto;
}



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/utils/capitalizarPrimera.ts